import React, { useEffect, useMemo, useState } from "react";
import { SpellingSuggestion } from "@tlc/ls2pac/dto/SuggestionResult";
import {
  LSSearchParams,
  SearchParametersDwr,
  useLSSearch,
} from "./ls/LSSearch";
import { List, ListItem, ListItemText, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useLanguage } from "../../Language";
import axios from "axios";
import { useBranchLimits } from "../../BranchLimits";

export const LSSearchSpellingSuggestions = () => {
  const { translate } = useLanguage();
  const { configLimitedBranchIds, isConfigLimited } = useBranchLimits();

  const { searchParams, totalHits, loadingResults } = useLSSearch();

  const [searchSpellingSuggestions, setSearchSpellingSuggestions] = useState<
    SpellingSuggestion[]
  >([]);

  const getSpellingSuggestions = async (
    params: LSSearchParams
  ): Promise<SpellingSuggestion[]> => {
    try {
      const payload: SearchParametersDwr = {
        searchTerm: params.term,
        hitsPerPage: 0,
        sortCriteria: "",
        facetFilters: [],
        branchFilters: [],
      };

      if (params.facetFilters) {
        payload.facetFilters = params.facetFilters;
      }

      if (params.branchFilters && params.branchFilters.length > 0) {
        payload.branchFilters = params.branchFilters;
      } else if (isConfigLimited) {
        payload.branchFilters = configLimitedBranchIds;
      }

      if (params.audience) {
        payload.audienceCharacteristicsFilters = [params.audience];
      }

      const { data } = await axios.post<SpellingSuggestion[]>(
        "search/spellingSuggestions",
        payload
      );
      return data;
    } catch (error) {
      console.error("Error fetching spelling suggestions:", error);
      return [];
    }
  };

  useEffect(() => {
    if (loadingResults || totalHits > 0 || searchParams.hasFilters) {
      setSearchSpellingSuggestions([]);
      return;
    }

    let isCurrent = true;

    getSpellingSuggestions(searchParams)
      .then((data) => {
        if (isCurrent) setSearchSpellingSuggestions(data);
      })
      .catch(() => {
        if (isCurrent) setSearchSpellingSuggestions([]);
      });

    return () => {
      isCurrent = false;
    };
  }, [searchParams, totalHits, loadingResults]);

  return (
    <>
      {searchSpellingSuggestions.length > 0 && (
        <>
          <Typography>{translate("spellingSuggestionsHeader")}</Typography>

          <List>
            {searchSpellingSuggestions.map((s) => (
              <ListItem key={s.suggestion} disablePadding>
                <ListItemText
                  primary={
                    <Link
                      to={`/search/ls?term=${encodeURIComponent(s.suggestion)}`}
                    >
                      {s.suggestion} ({s.resourceCount})
                    </Link>
                  }
                />
              </ListItem>
            ))}
          </List>
        </>
      )}
    </>
  );
};
